// extracted by mini-css-extract-plugin
export default {"product":"BaseProduct_product__ryfWI","productImage":"BaseProduct_productImage__SS6wJ","productImageContainer":"BaseProduct_productImageContainer__a3xUY"};